<nav
  class="pagination-wrapper"
  [class.justify-content-center]="alignment === 'center'"
  [class.justify-content-end]="alignment === 'end'"
  [class.pagination-total]="totalNumberText.hasChildNodes()">
  @if (currentChanger !== undefined) {
    <div class="dropdown">
      <button class="btn btn-dropdown dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        {{ currentChanger }} / pagina
      </button>
      <div class="dropdown-menu">
        <div class="link-list-wrapper">
          <ul class="link-list">
            @for (value of changerValues; track value) {
              <li><a class="dropdown-item list-item" href="#" externalLink="true" (click)="changerChange($event, value)">
                {{ value }} / pagina</a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  }

  @if (pages.length) {
    <ul class="pagination">
      <li class="page-item" [class.disabled]="currentPage < 1">
        <a class="page-link" [class.text]="textLinks" href="#" (click)="pageChange($event, currentPage)">
          @if (!textLinks) {
            <i class="bi bi-chevron-left"></i>
          }
          <span class="visually-hidden">
            {{ (textLinks ? 'Pagina' : 'Pagina precedente') }}
          </span>
          @if (textLinks) {
            Pagina precedente
          }
        </a>
      </li>
      @if (simpleMode) {
        <li class="page-item">
          <span class="page-link" aria-current="page">{{ currentPage + 1 }}</span>
        </li>
        <li class="page-item"><span class="page-link">/</span></li>
        <li class="page-item">
          <span class="page-link">{{ pageNumbers }}</span>
        </li>
        <li class="page-item visually-hidden">
          <a class="page-link" href="#" aria-current="page">
            Pagina {{ currentPage + 1 }} di {{ pageNumbers }}
          </a>
        </li>
      } @else {
        @if (pageNumbers > visiblePages && pages[0] >= 2) {
          <li class="page-item">
            <a class="page-link" href="#" (click)="pageChange($event, 1)">1</a>
          </li>
          @if (pages[0] >= 3) {
            <li class="page-item">
              <span class="page-link">...</span>
            </li>
          }
        }
        @for (page of pages; track page) {
          <li class="page-item">
            @if (page === currentPage + 1) {
              <a class="page-link" aria-current="page">
                <span class="d-inline-block d-sm-none">Pagina</span> {{ page }}
              </a>
            } @else {
              <a class="page-link" href="#" (click)="pageChange($event, page)">{{ page }}</a>
            }
          </li>
        }
        @if (pageNumbers > visiblePages && pages[pages.length - 1] < pageNumbers) {
          @if (pages[pages.length - 1] < pageNumbers - 1) {
            <li class="page-item">
              <span class="page-link">...</span>
            </li>
          }
          <li class="page-item">
            <a class="page-link" href="#" (click)="pageChange($event, pageNumbers)">{{ pageNumbers }}</a>
          </li>
        }
      }
      <li class="page-item" [class.disabled]="currentPage >= pageNumbers - 1">
        <a class="page-link" [class.text]="textLinks" href="#" (click)="pageChange($event, currentPage + 2)">
          <span class="visually-hidden">
            {{ (textLinks ? 'Pagina' : 'Pagina successiva') }}
          </span>
          @if (textLinks) {
            Successiva
          } @else {
            <i class="bi bi-chevron-right"></i>
          }
        </a>
      </li>
    </ul>
  }

  <!-- @if (showJumpToPage) {
    <it-input
      type="number"
      [min]="1"
      [max]="pageNumbers"
      [label]="('it.core.go-to' | translate) + '...'"
      [formControl]="jumpToPage"></it-input>
  } -->

  <p [class.d-none]="!totalNumberText.hasChildNodes()" #totalNumberText>
    <ng-content></ng-content>
  </p>
</nav>
